import { GreenCheck } from '@assets/icons';
import ModalComponent from '@components/modal/Modal.component';
import NewTableComponent from '@components/table/NewTable.component';
import { Colors } from '@constants/colors.constants';
import CloseIcon from '@mui/icons-material/Close';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material';
import { GridValueGetterParams, GridValueSetterParams } from '@mui/x-data-grid-pro';
import { useObservable } from '@ngneat/react-rxjs';
import {
  AuditOfferSupplierLightDto
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.model';
import {
  auditsProposalSuppliersQuery
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.query';
import {
  auditProposalSuppliersServices
} from '@store/audits/audit-offer-followUp/audit-proposal-suppliers/audit-proposal-suppliers.services';
import { auditOfferFollowUpQuery } from '@store/audits/audit-offer-followUp/audits-offer-followUp.query';
import { serviceKindsService, ServiceKindTypeEnum } from '@store/settings/serviceKinds';
import COLUMN_TYPES from '@utils/table/columnTypes.table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { finalize, map } from 'rxjs';

import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { useEffectFn } from '@ngneat/effects-hooks';
import { AuditProposalSupEmailEffectfn } from '@store/audits/audit-offer-followUp/audits-offer-followUp.effects';
import { OtherActionType } from '@utils/table/columnTypes/actions.columnType';
import _ from 'lodash';
import HistoryPopover from './HistoryPopover';

enum DetailStatusEnum {
  ACCEPTED = 'ACCEPTED',
  DENIED = 'DENIED',
  NONE = 'NONE',
}

interface DetailsStatusProps {
  handleClose: () => void;
  partnerStatusId?: string;
  isPending?: boolean;
  handleSucceed?: (value: AuditOfferSupplierLightDto[]) => void;
}

const DetailsStatus = (props: DetailsStatusProps) => {
  const { handleClose, partnerStatusId, isPending, handleSucceed } = props;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState<ServiceKindTypeEnum>();
  const [offerItem, setOfferItem] = useState<{
    label: string;
    value: ServiceKindTypeEnum;
  }[]
  >();
  const [{ allAuditsOfferSupFromProposalSup }] = useObservable(auditsProposalSuppliersQuery.allAuditsOfferSupFromProposalSup$);
  const [{ auditsProposalSupplierDetails }] = useObservable(auditsProposalSuppliersQuery.auditsProposalSupplierDetails$);
  const [{ auditsProposalDetails }] = useObservable(auditOfferFollowUpQuery.auditProposalDetails$);
  const partner = allAuditsOfferSupFromProposalSup ? allAuditsOfferSupFromProposalSup[0]?.auditProposal : '';
  const [anchorEl, setAnchorEl] = useState(null);
  const [OfferSup, setOfferSup] = useState<AuditOfferSupplierLightDto[]>([]);
  const [firstTime, setFirstTime] = useState(false);
  const [email, setEmail] = useState<string>(auditsProposalSupplierDetails?.email || '');

  const OfferSupfiltered = OfferSup.filter((it) => it.family.includes(tabs || ''));

  const editEmailProposalSup = useEffectFn(AuditProposalSupEmailEffectfn);

  useEffect(() => {
    if (auditsProposalSupplierDetails?.id && email) {
      editEmailProposalSup({ auditsProposalDetailsId: auditsProposalSupplierDetails.id, email: email });
    }
  }, [email, editEmailProposalSup, auditsProposalSupplierDetails]);

  useEffect(() => {
    if (OfferSup && OfferSup?.length > 0 && !firstTime) {
      const allAvaillaibleFamilly = OfferSup.map((it) => it.family);
      const tabsFamilly = _.intersection(Object.keys(ServiceKindTypeEnum), allAvaillaibleFamilly);
      const allTabs = ServiceKindTypeEnum.selectItems().filter((it) => tabsFamilly.includes(it.value));
      setTabs(allTabs[0]?.value);
      setOfferItem(allTabs);
      setFirstTime(true);
    }
  }, [OfferSup, firstTime]);

  useEffect(() => {
    if (partnerStatusId) {
      setLoading(true);
      auditProposalSuppliersServices
        .getAuditsOfferSupFromProposalSup(partnerStatusId)
        .pipe(finalize(() => setLoading(false)))
        .subscribe({ next: setOfferSup });
    }
  }, [partnerStatusId]);

  const items = [
    { label: 'Sélectioner', value: DetailStatusEnum.NONE },
    { label: 'Refusé', value: DetailStatusEnum.DENIED, color: Colors.error, backgroundColor: '#e6433c33', },
    { label: 'Accepté', value: DetailStatusEnum.ACCEPTED, color: Colors.success, backgroundColor: '#58e06d33', }
  ];

  const getLabels = (value: string) => {
    const item = items.find((it) => it.value === value);
    return item?.label;
  };

  const handleClickAnchorEl = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchorEl = () => {
    setAnchorEl(null);
  };

  const isValidate = !!auditsProposalSupplierDetails?.validatedAt;
  const open = Boolean(anchorEl);

  return (
    <ModalComponent
      aria-label="over-drawer"
      title={t('audits.auditOfferFollowUp.modal.detailsOffer.titlePartner', { offer: auditsProposalDetails?.name, partner: partner })}
      handleClose={handleClose}
      contentFullWidth
      maxWidth='lg'
      content={(
        <Stack width="100%" height='70dvh' bgcolor='#FFFFFF' spacing={3}>
          <Tabs
            value={tabs}
            onChange={(_, value) => setTabs(value)}
            aria-label={'primary'}
            variant="scrollable"
            sx={{ color: '#192133', paddingLeft: '24.5px' }}
          >
            {offerItem?.map((it) => (
              <Tab
                key={`Tab ${it.value} - ${it.label}`}
                label={it.label}
                value={it.value}
              />
            ))}
          </Tabs>
          <NewTableComponent
            columns={[
              COLUMN_TYPES.TEXT({
                field: 'container',
                width: 200,
                color: 'secondary',
                label: 'Contenant',
              }),
              COLUMN_TYPES.TEXT({
                field: 'waste',
                width: 200,
                color: 'secondary',
                label: 'Type de déchet',
              }),
              COLUMN_TYPES.ASYNC_SELECT({
                field: 'serviceKind',
                cellClassName: () => 'bold',
                label: 'Prestation',
                getOptions: (search) => serviceKindsService.searchServiceKinds(search).pipe(
                  map((options) =>
                    options.data.map((o) => ({ label: o.kind || '-', value: o.id, data: o }))
                  )
                ),
                valueGetter: (params: GridValueGetterParams<any, AuditOfferSupplierLightDto>) => params.row?.serviceKind?.kind,
                valueFormatter: (params) => params?.value,
                width: 250,
              }),
              COLUMN_TYPES.NUMBER({
                field: 'unitCostInCents',
                label: 'Prix',
                sortable: true,
                valueGetter: (params: GridValueGetterParams<any, AuditOfferSupplierLightDto>) => params.row?.unitCostInCents,
                valueFormatter: (params) => params?.value ? (params?.value / 100).toFixed(2) : undefined,
                valueSetter: (params: GridValueSetterParams) => {
                  return {
                    ...params.row,
                    unitCostInCents: params.row.unitCostInCents === params.value ? params.value : params.value * 100
                  };
                },
                unitName: () => (
                  <Typography fontSize='14px' fontWeight={400} color='#192133'>
                    CHF
                  </Typography>
                ),
                width: 150,
              }),
              COLUMN_TYPES.SELECT({
                field: 'status',
                width: 130,
                color: 'secondary',
                label: 'Statut',
                options: items,
                customRenderValue: (value: string) =>
                  <Box alignItems='center' sx={{ display: 'flex', gap: 1 }}>
                    {value === DetailStatusEnum.ACCEPTED ? <GreenCheck style={{ marginLeft: '3px' }} /> :
                      value === DetailStatusEnum.DENIED ? <CloseIcon color='error' sx={{ height: '16px', width: '16px' }} /> : undefined}
                    {!value ? 'Sélectionner' : getLabels(value)}
                  </Box>
              }),
              COLUMN_TYPES.CUSTOM({
                field: 'button',
                width: 60,
                color: 'secondary',
                label: '',
                editable: true,
                renderCell: (params: GridValueGetterParams<any, AuditOfferSupplierLightDto>) => {
                  return !isPending && params.row.costHistory?.length > 1 ? (
                    <Stack width="100%" alignItems='center' >
                      <Stack
                        border={`1px solid ${Colors.primary}`}
                        borderRadius='4px'
                        color={Colors.white}
                        p='5px'
                        maxHeight={'30px'}
                        maxWidth={'30px'}
                        onClick={handleClickAnchorEl}
                      >
                        <ListAltRoundedIcon sx={{ height: '16px', width: '16px', color: Colors.black }} />
                      </Stack>
                      <HistoryPopover
                        history={params.row.costHistory}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleCloseAnchorEl}
                      />
                    </Stack>
                  ) : undefined;
                },
              }),
              COLUMN_TYPES.ACTIONS({
                otherActions: [
                  {
                    type: OtherActionType.EDIT
                  },
                ],
              }),
            ]}
            disablePagination
            disableRowSelectionOnClick={true}
            disableRowSelection={true}
            loading={loading}
            handleRowChanged={(value: AuditOfferSupplierLightDto) => {
              const OfferSupCopy = [...OfferSup];
              const index = OfferSupCopy.findIndex((it) => it.id === value.id);
              const updatedOfferSup = {
                status: value.status ?? DetailStatusEnum.NONE,
                unitCostInCents: value.unitCostInCents ?? 0,
                serviceKind: (value.serviceKind as any)?.data ? (value.serviceKind as any).data : OfferSupCopy[index].serviceKind,
              };
              OfferSupCopy[index] = { ...OfferSupCopy[index], ...updatedOfferSup };
              setOfferSup(OfferSupCopy);
              return { ...OfferSupCopy, ...value };
            }}
            data={OfferSupfiltered || []}
          />

          <Stack direction='row' spacing={2} sx={{ alignSelf: 'center', zIndex: 1, bottom: '20px', position: 'absolute' }}>
            <Stack pl="24.5px" maxWidth={'350px'}>
              <TextFieldComponent
                labelWidth={80}
                label="Email"
                value={email}
                placeholder='Email du partenaire'
                handleChange={setEmail}
              />
            </Stack>
            <Button
              sx={{ width: '100px' }}
              variant="contained"
              color="primary"
              disabled={OfferSup.some((it) => it.status.includes(DetailStatusEnum.NONE))}
              onClick={() => handleSucceed?.(OfferSup)} >
              {isValidate ? t('global.save') : t('global.send')}
            </Button>
          </Stack>
        </Stack >
      )}
    />
  );
};

export default DetailsStatus;
